import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { RootStoreContext } from './global/storeContext';
import { rootStore } from './stores/rootStore';
import Gatekeeper from './components/gatekeeper/gatekeeper';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const defaultTheme = createTheme();
root.render(
    <RootStoreContext.Provider value={rootStore}>
        <Gatekeeper
            initialize={async () => {
                while (!rootStore.userStore.isAuthReady) {
                    await new Promise((resolve) => setTimeout(resolve, 2000));
                }
                return Promise.resolve();
            }}
        >
            <ThemeProvider theme={defaultTheme}>
                <BrowserRouter basename=''>
                    <App />
                </BrowserRouter>
            </ThemeProvider>
        </Gatekeeper>
    </RootStoreContext.Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
